import { Transform, Exclude, Expose } from "class-transformer";
import { RestrictionsManager } from "@modules";

@Exclude()
export class UpdateAttributeTypeItemDto {
    @Expose()
    readonly type_id: number;

    @Expose()
    readonly vtype_id: number;

    @Expose()
    readonly sorting: number;

    @Expose()
    @Transform(({ obj, value }) =>
        obj.useRestrictions ? RestrictionsManager.getRestrictionsObjectFromArray(value) : undefined
    )
    readonly restrictions?: any;
}
